export const PROMOTER_ADVANCES_RECORD_KEY = 'promoter_advances';
export const PROMOTER_ADVANCES_FILES_RECORD_KEY = 'promoter_advance_files';
